export default "__VITE_ASSET__BBanRF7i__"